(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
     
document.addEventListener("DOMContentLoaded", function() {
  let video = document.querySelector(".video-container video");
  let playButton = document.getElementById("playButton");
  let videoIsPlaying = document.querySelector('.video-is-playing');

  // Ensure video and playButton elements exist
  if (video && playButton) {
    playButton.addEventListener("click", function() {
      if (video.paused) {
        video.play();
        video.parentElement.classList.add("video-is-playing");
        playButton.style.display = 'none';
      } else {
        video.pause();
        video.parentElement.classList.remove("video-is-playing");
        playButton.style.display = 'block';
      }
    });

    video.addEventListener('click', function() {
      video.pause();
      video.parentElement.classList.remove("video-is-playing");
      playButton.style.display = 'block'; // Ensure this is set here too
    });

    video.addEventListener('ended', function() {
      video.parentElement.classList.remove("video-is-playing");
      playButton.style.display = 'block'; // Reset playButton visibility when video ends
    });
  }

  // Check for the 'videoIsPlaying' element before using it
  if (video && videoIsPlaying) {
    video.addEventListener('click', () => {
      video.pause();
      playButton.style.display = 'block';
      videoIsPlaying.classList.remove('video-is-playing');
    });
  }
});

    
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mbl-special-collection"]) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  let video = document.querySelector(".video-container video");
  let playButton = document.getElementById("playButton");
  let videoIsPlaying = document.querySelector('.video-is-playing');

  // Ensure video and playButton elements exist
  if (video && playButton) {
    playButton.addEventListener("click", function() {
      if (video.paused) {
        video.play();
        video.parentElement.classList.add("video-is-playing");
        playButton.style.display = 'none';
      } else {
        video.pause();
        video.parentElement.classList.remove("video-is-playing");
        playButton.style.display = 'block';
      }
    });

    video.addEventListener('click', function() {
      video.pause();
      video.parentElement.classList.remove("video-is-playing");
      playButton.style.display = 'block'; // Ensure this is set here too
    });

    video.addEventListener('ended', function() {
      video.parentElement.classList.remove("video-is-playing");
      playButton.style.display = 'block'; // Reset playButton visibility when video ends
    });
  }

  // Check for the 'videoIsPlaying' element before using it
  if (video && videoIsPlaying) {
    video.addEventListener('click', () => {
      video.pause();
      playButton.style.display = 'block';
      videoIsPlaying.classList.remove('video-is-playing');
    });
  }
});

    
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
